export default __webpack_public_path__ + "static/step0101-4b766b9eaca1768b7a7ca9eb17e997ae.jpg";